import axios from 'axios'
import store from '@/store'
import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: 'https://rz.iflyad.com/airz/api/index/v1', // 线上环境
  // baseURL: 'https://study.whhmzf.top/ai_rz/api/index/v1', // 测试环境
  timeout: 60000 // 请求超时时间
})

// 异常拦截处理器
const errorHandler = error => {
  if (error.response) {
    const data = error.response.data
    // 从 localstorage 获取 token
    const token = window.localStorage.getItem('token')
    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message
      })
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      notification.error({
        message: 'Unauthorized',
        description: 'Authorization verification failed'
      })
      if (token) {
        store.dispatch('Logout').then(() => {
          // setTimeout(() => {
          //   window.location.reload()
          // }, 1500)
        })
      }
    }
  }
  return Promise.reject(error)
}

// 请求拦截器
request.interceptors.request.use(config => {
  const token = window.localStorage.getItem('token')
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    config.headers['Token'] = token
  }
  return config
}, errorHandler)

// 响应拦截器
request.interceptors.response.use(response => {
  const code = response.data.code
  if (code == 2000 || code == 1302 || code == 1303) {
    window.localStorage.removeItem('token')
    store.dispatch('Logout').then(() => {
      // setTimeout(() => {
      //   window.location.reload()
      // }, 1500)
    })
  }
  return response.data
}, errorHandler)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export { installer as VueAxios, request as axios }
